<template>
    <div>
        <p class="pb-3">
            {{label}}
        </p>
       <vs-slider :max="max" :min="min" :disabled="disabled" v-model="answerSend" />
       <span class="ml-3">
           {{answerSend}}
       </span>
    </div>

</template>


<script type="text/javascript">
    import { mapState, mapMutations } from 'vuex';
    export default {
        props: {
            label: {
                type: String,
                required: false,
                default: 'Descripción'
            },
            answer: {
                type:  [String, Number],
                required: false,
                default: 0
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        computed: {
            ...mapState('resource', ['indexQuestion', 'questionsByPage']),
            /**
             * Obtiene le valor mínimo de la propiedad de la pregunta
             */
            max() {
                return this.questionsByPage[this.indexQuestion].properties.maxValue;
            },
            /**
             * Obtiene el valor mínimo de la propiedad
             */
            min() {
                return this.questionsByPage[this.indexQuestion].properties.minValue;
            },
            /**
             * Envia el valor seleccionado del componente
             */
            answerSend: {
                get() {
                    if(this.answer === '') return this.questionsByPage[this.indexQuestion].properties.minValue;
                    const convertToInt = parseInt(this.answer)
                    return convertToInt;
                },
                set(value) {
                    this.$emit('input', String(value))
                }
            }
        }

    }
</script>
